import Handlebars from "utilities/vendor/handlebars/4.7.6/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.6/js/handlebars";
import focusTrapUtility from "utilities/global/focus-trap-utility/1.2.3/js/focus-trap-utility";
import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.3/js/sparta-events-utility";
import "utilities/global/sparta-global-data-utility/1.0.0/js/sparta-global-data-utility";
import spartaGlobalFunctions from "utilities/global/sparta-global-functions-utility/2.1.2/js/sparta-global-functions-utility";
import spartaMediaQueryUtility from "utilities/global/sparta-mediaquery-utility/3.0.5/js/sparta-mediaquery-utility";
import spartaSingletonUtility from "utilities/global/sparta-singleton-utility/1.0.0/js/sparta-singleton-utility";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.1/js/sparta-store-utility";
import spartaStyleUtility from "utilities/global/sparta-style-utility/4.4.0/js/sparta-style-utility";
import cardHelper from "utilities/helpers/helpers-card/1.2.0/js/helpers-card";
import spartaHelpers from "utilities/helpers/helpers-sparta/3.0.5/js/helpers-sparta";
import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import SpartaUILayersModal from "utilities/global/sparta-ui-layers-utility/6.4.1/js/sparta-ui-layers-utility-modal";
import SpartaUILayersTooltip from "utilities/global/sparta-ui-layers-utility/6.4.1/js/sparta-ui-layers-utility-tooltip";







const focusTrap = focusTrapUtility({});


const classDefaults = {
  debug: false,
  evtNamespace: 'spaUILayer',
  closeLayerNameSpace: 'info-layer-evt',
  initNamespace: 'sparta-ui-layers-utility',
  scrollNamespace: 'scrollfix',
  globalReady: 'SPARTA_GLOBAL_READY.spartaBootstrapUtility',
  globalReadyToken: '',
  layerClass: 'spa-ui-layer',
  layerPosition: '',
  linkClass: 'spa-ui-layer-link',
  closeClass: 'spa-ui-layer-close',
  openClass: 'spa-ui-layer-opened',
  activeTooltip: 'spa-ui-tooltip-open',
  activeModal: 'spa-ui-modal-open',
  noCloseFocus: 'spa-card__ada-msg',
  noCloseFocusAuto: true,
  adaLayerID: 'SpartaUILayer',
  adaCloseID: 'Close',
  modalLayerClass: 'spa-ui-modal',
  infoLayerClass: 'spa-ui-info',
  infoInlineLayerClass: 'spa-ui-info-info-inline',
  layerLinkOffset: 14, 
  layerIconOffset: 14, 
  layerCaret: 14, 
  nextZIndex: 1001,
  continueLinkPostfixID: 'ContinueLink',
  backLinkPostfixID: 'BackLink',
  spartaLayoutContainer: '.spa-layout-container', 
};


const linkDefaults = {
  type: null, 
  width: null, 
  layerId: null,
  layerCloseId: null,
  layerClass: 'spa-ui-layer',
  optionalClasses: '',
  onOpen: '', 
  onClose: '', 
  closeButton: true, 
  closeTriggers: [], 
  closeOnEscape: true, 
  closeOnClickOutside: true,
  closeAdaText: '',
  closeAdaTextClean: '',
  closeAdaTextSpacer: ': ',
  closeAdaTextOverride: '',
  interstitialType: '',
  adaCloseFocus: false, 
  interstitialBranding: 'default',
  dynamicContent: false,
  enableDynamicHeight: false, 
  loadingText: '',
  targetAction: '',
  modalTitle: '',
  modalLayer: {
    class: classDefaults.modalLayerClass,
    width: 600,
  },
  infoLayer: {
    class: classDefaults.infoLayerClass,
    layerAdjustTop: 10,
    layerAdjustLeft: 10,
    width: {
      small: {
        chars: 350,
        width: 250,
        class: `${classDefaults.infoLayerClass}-small`,
      },
      medium: {
        chars: 800,
        width: 400,
        class: `${classDefaults.infoLayerClass}-medium`,
      },
      large: {
        chars: 0,
        width: 400,
        class: `${classDefaults.infoLayerClass}-large`,
      },
      default: {
        width: 250,
        class: `${classDefaults.infoLayerClass}-large`,
      },
    },
  },
};


const EVENTS = {
  MODAL_OPENED: 'MODAL_OPENED.spartaUILayersUtility',
  MODAL_CLOSED: 'MODAL_CLOSE.spartaUILayersUtility',
  FREEZE_SCROLL: 'FREEZE_SCROLL.spartaUILayersUtility',
  UNFREEZE_SCROLL: 'UNFREEZE_SCROLL.spartaUILayersUtility',
};


const options = {
  debug: false,
  $applicationContainer: null,
  $body: $('body'),
  $html: $('html'),
  $window: $(window),
  $document: $(document),
  $context: null,
};




class SpartaUILayersUtility {



  constructor() {

    this.isPrerender = (typeof startPrerenderCapture === 'function');
    if (this.isPrerender) {
      return;
    }


    this.options = Object.assign({}, classDefaults, options);


    this.options.globalReadyToken = spartaEventsUtility.sub(
      `${this.options.globalReady}`,
      this._addListeners.bind(this),
    );

    this._addTriggerTypeClass(this.options.linkClass);



    this.options.windowWidth = this.options.$window.width();
  }






  _addTriggerTypeClass(className) {

    const uiLinkList = [...document.querySelectorAll(`.${className}`)];

    uiLinkList.forEach((element) => {

      if (element.parentElement.nodeName === 'ABBR') {
        return;
      }


      let targetID;
      let targetDataObj;
      let type;

      if (element && element.dataset && element.dataset.options) {
        let linkOptions;
        try {
          linkOptions = JSON.parse(element.dataset.options);
        } catch (e) {
          console.log(`Error message: ${e.message}`);
        }


        if (linkOptions && linkOptions.interstitialType) {

          type = 'modal';
        } else {

          targetID = element.getAttribute('rel');
        }
      }


      const target = targetID
        ? document.getElementById(targetID)
        : undefined;


      if (target && target.dataset && target.dataset.options) {
        try {
          targetDataObj = JSON.parse(target.dataset.options);
        } catch (e) {
          console.log(`Error message: ${e.message}`);
        }
        if (targetDataObj && targetDataObj.type) {
          ({ type } = targetDataObj);
        }
      }


      if (type === 'modal') {
        element.classList.add('spa-ui-layer-modal-link');
      } else if (type === 'info') {
        element.classList.add('spa-ui-layer-tooltip-link');
      }
    });
  }







  get layers() {
    const lang = spartaGlobalFunctions.getLanguage();
    const spaParam = spartaGlobalFunctions.getSpaParams();
    const layersObj = spaParam.global[lang].layers;
    return layersObj;
  }





  get EVENTS() {
    return EVENTS;
  }





  _addListeners() {

    this.options.$applicationContainer = $(spartaStoreUtility.getData('applicationContainer'));

    spartaEventsUtility.unsubByToken(this.options.globalReadyToken);

    if (this.options.$applicationContainer[0].hasAttribute('data-sparta-widget')) {
      spartaEventsUtility.unsubWidgetByToken(this.options.globalReadyToken);
    }

    const namespace = this.options.evtNamespace;
    this.options.$applicationContainer.on(
      `click.${namespace}`,
      `.${this.options.linkClass}`,
      this._onLayerLinkClick.bind(this),
    );

    this.options.$applicationContainer.on(
      `animationend.${namespace} oAnimationEnd.${namespace} webkitAnimationEnd.${namespace}`,
      this._infoLayerAnimationEnd.bind(this),
    );
  }







  displayPopup(url, windowName, args = 'width=750,height=450,resizable,scrollbars') {
    if (this.isPrerender) {
      return false;
    }

    const newWindow = window.open(url, windowName, args);
    newWindow.focus();

    return false;
  }






  addPopupWindowHelper(elements) {
    if (this.isPrerender) {
      return;
    }

    const popupElements = Array.prototype.slice.call(elements, 0);

    popupElements.forEach((elem) => {
      if (elem.getAttribute('data-popup-event-attached')) {
        return;
      }
      elem.addEventListener('click', ((event) => {
        event.preventDefault();

        let args = '';
        const $elem = $(elem);
        const defaults = {
          block: false,
          height: 600,
          href: $elem.attr('href'),
          menubar: false,
          resizable: true,
          scrollbars: true,
          size: null,
          status: false,
          width: 400,
          windowName: 'spawin',
          x: 0,
          y: 0,
        };
        const opts = Object.assign({}, defaults, ($elem.data('options') || {}));
        const sizes = {
          large: {
            height: 600,
            width: 800,
          },
          medium: {
            height: 400,
            width: 600,
          },
          small: {
            height: 200,
            width: 300,
          },
        };

        if (opts.size) {
          opts.width = sizes[opts.size].width;
          opts.height = sizes[opts.size].height;
        }



        opts.y = Math.floor((window.screen.availHeight - (opts.height || window.screen.height)) / 2)
          - (window.screen.height - window.screen.availHeight);
        opts.x = Math.floor((window.screen.availWidth - (opts.width || window.screen.width)) / 2)
          - (window.screen.width - window.screen.availWidth);


        if (!opts.block) {
          const {
            width,
            height,
            x,
            y,
          } = opts;
          args = `${args}width=${width},height=${height},left=${x},top=${y}`;

          ['menubar', 'resizable', 'scrollbars', 'status'].forEach((toolbarFeature) => {
            if (opts[toolbarFeature]) {
              args += `,${toolbarFeature}`;
            }
          });
        }

        this.displayPopup(opts.href, opts.windowName, args);

        elem.classList.add('force-visited');
        return false;
      }));
      elem.setAttribute('data-popup-event-attached', '1');
    });
  }






  _onLayerLinkClick(event) {
    const $this = $(event.currentTarget);
    this.openLayer($this, event);
  }






  _infoLayerAnimationEnd(e) {
    const $target = $(e.target);


    if (
      $target.hasClass('spa-ui-animate-fadeOutUp')
      || $target.hasClass('spa-ui-animate-fadeOutDown')
    ) {
      $target.hide();
    }
  }








  _setLayerOptions(linkSpecificSettings = {}, contentOptions = {}, linkOptions = {}) {
    return Object.assign({}, linkDefaults, linkSpecificSettings, contentOptions, linkOptions);
  }









  openLayer(obj, e, layerOptions) {
    if (this.isPrerender) {
      return;
    }

    const event = e || {};


    if (event.type) {
      event.preventDefault();
    }


    const $obj = (obj && !obj.jquery) ? $(obj) : obj;


    if (!$obj || !$obj.length) {
      this._debug('Error: spartaUILayer: Nothing passed in');
      return;
    }


    this.options.$applicationContainer = event.$applicationContainer
      || $(spartaStoreUtility.getData('applicationContainer'));


    this.options.$applicationContainerDisableAriaHiddenToggle = false;
    if (this.options.$applicationContainer.hasClass('sparta-widget-container')) {
      this.options.$applicationContainerDisableAriaHiddenToggle = true;
    }

    let $link;
    let $content;
    let contentId;
    let linkOptions = {};

    let triggerLink;
    if (e) {
      triggerLink = e.currentTarget || (e.target || e.srcElement);
    }


    if ($obj.hasClass(this.options.linkClass)) {
      $link = $obj;

      linkOptions = $link.data('options') || {};
      contentId = $link.attr('rel');


      if (linkOptions.interstitialType) {
        linkOptions.type = 'modal';
        contentId = linkOptions.rel
          || `${linkOptions.interstitialType}-${linkOptions.interstitialBranding || 'default'}`;
      }

      $content = $(`#${contentId}`) || null;
    } else if (triggerLink) {
      $content = $obj;
      $link = $(triggerLink);
      contentId = $content.attr('id');
    } else if (e === null && layerOptions && layerOptions.returnFocusToLink) {
      $content = $obj;
      $link = $(layerOptions.returnFocusToLink);
      contentId = $content.attr('id');
    } else {
      $content = $obj;
      $link = this.options.$applicationContainer;
      contentId = $content.attr('id');
    }

    const contentOptions = $content.data('options') || {};
    const returnFocusToLink = event.currentTarget || (event.target || event.srcElement);


    const linkSpecificSettings = {
      closeADALabel: spartaGlobalFunctions.getGlobalParams('closeADALabel') || 'x: ',
      closeText: spartaGlobalFunctions.getGlobalParams('closeText') || 'close',
      $content,
      contentId,
      startContentMsg: spartaGlobalFunctions.getGlobalParams('layerStart') || 'Start of [layerType] content',
      endContentMsg: spartaGlobalFunctions.getGlobalParams('layerEnd') || 'End of [layerType] content',
      endContentMsgShowOnFocus: true,
      returnFocusToLink: returnFocusToLink
        ? $(returnFocusToLink)
        : this.options.$applicationContainer,
      position: {
        browserWidth: this.options.$body.width(),
        applicationWidth: this.options.$applicationContainer.width(),
        activeMouseTop: event.pageY,
        activeMouseLeft: event.pageX,
        linkWidth: $link.width(),
        linkHeight: $link.height(),
        linkOffsetTop: $link.offset().top,
        linkOffsetLeft: $link.offset().left,
        screenTop: this.options.$document.scrollTop(),
      },
    };



    let o = this._setLayerOptions(linkSpecificSettings, contentOptions, linkOptions);


    o.typeNiceName = o.type === 'info'
      ? spartaGlobalFunctions.getGlobalParams('closeLayerADAText') || 'popup'
      : spartaGlobalFunctions.getGlobalParams('closeModalADAText') || 'modal';
    o.endContentMsg = o.endContentMsg.replace('[layerType]', o.typeNiceName.toLowerCase());


    o = Object.assign({}, o, layerOptions);


    if (!(o.returnFocusToLink instanceof $)) {
      o.returnFocusToLink = this.options.$applicationContainer.find(o.returnFocusToLink)
        .slice(0, 1);
    }


    if (o.modalTitle) {
      o.title = o.modalTitle;
    }


    if (typeof o.$content === 'undefined') {
      o.$content = $(`#${o.contentId}`);


      if (typeof o.$content === 'undefined' && typeof o.interstitialType === 'undefined') {
        this._debug(`cannot find: ${o.contentId}`);
        return;
      }
    }



    o.layerId = `${o.contentId}${this.options.adaLayerID}`;
    o.layerCloseId = `${o.layerId}${this.options.adaCloseID}`;


    let $layer;
    switch (o.type) {
      case 'modal':
        $layer = this._openModalLayer(o, $layer, $link);
        $layer.addClass(classDefaults.activeModal);
        this.options.$applicationContainer.addClass(classDefaults.activeModal);
        break;
      case 'info':
      case 'info-inline':
        $layer = this._openInfoLayer(o, $layer, $link);
        $layer.addClass(classDefaults.activeTooltip);
        this.options.$applicationContainer.addClass(classDefaults.activeTooltip);
        break;
      default:
        return;
    }


    if (o.layerPosition) {
      $layer[0].firstElementChild.classList.add(`spa-ui-position-${o.layerPosition.toLowerCase()}`);
    }


    const $modalElement = $layer.find('.spa-content');
    const $layerElement = $layer.find('.spa-card__body');
    const $contentDiv = $modalElement.find('.content');
    const $layerDiv = $layerElement.find('.content');
    const contentDiv = $contentDiv[0];
    const layertDiv = $layerDiv[0];
    const resizeContentBody = function resizeContentBody() {
      if (!contentDiv || o.type !== 'modal') {
        return;
      }

      let contentBodyChanged = false;


      let origMaxHeight = parseInt(contentDiv.getAttribute('data-orig-max-height'), 10);
      if (!origMaxHeight) {
        origMaxHeight = parseInt(window.getComputedStyle(contentDiv).maxHeight, 10);
        contentDiv.setAttribute('data-orig-max-height', origMaxHeight);
      }



      const windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
      if ($modalElement[0].scrollHeight > windowHeight) {
        const amountToReduce = $modalElement[0].scrollHeight
          - windowHeight;
        contentDiv.style.maxHeight = `${contentDiv.offsetHeight - amountToReduce - 25}px`;
        contentBodyChanged = true;
      } else {

        const amountToIncrease = windowHeight - $modalElement[0].scrollHeight;
        if (contentDiv.offsetHeight + amountToIncrease > origMaxHeight) {
          contentDiv.style.maxHeight = `${origMaxHeight}px`;
        } else if (amountToIncrease > 0) {
          contentDiv.style.maxHeight = `${(contentDiv.offsetHeight + amountToIncrease) - 25}px`;
        }

        contentBodyChanged = true;
      }


      if (contentBodyChanged) {
        $contentDiv.trigger('scroll.uilayer_content');
      }
    };


    if (contentDiv) {
      resizeContentBody.call(this);

      this.options.$window.on(
        'resize.closeModal orientationchange.closeModal',
        resizeContentBody.bind(this),
      );
    }


    if (layertDiv && o.type === 'info' && o.enableDynamicHeight) {
      const tooltipDynamicHeight = () => {
        this.tooltipDynamicHeight(layertDiv, $link);
      };
      this.tooltipDynamicHeight(layertDiv, $link);
      window.addEventListener('resize', window.tooltipFN = tooltipDynamicHeight, false);
      window.addEventListener('scroll', window.tooltipFN = tooltipDynamicHeight, false);
    }

    $layer.data('type', o.type);

    if (o.returnFocusToLink && o.returnFocusToLink[0] && o.returnFocusToLink[0].id) {
      $layer.data('returnFocusToLink', `#${o.returnFocusToLink[0].id}`);
    } else {
      $layer.data('returnFocusToLink', 'body');
    }

    $layer.data('contentId', o.contentId);

    let tooltipWithinModal = false;
    if (
      this.options.$applicationContainer.find(`.${classDefaults.infoLayerClass}`).length
      &&
      (
        this.options.$applicationContainer.find(`.${classDefaults.modalLayerClass}`).length
        ||
        this.options.$applicationContainer.find(`.${classDefaults.infoInlineLayerClass}`).length
      )
    ) {

      const modalLookup = this.options.$applicationContainer.find(`.${classDefaults.infoLayerClass}`)[0];
      const hasTooltip = modalLookup.querySelector(`.${classDefaults.modalLayerClass}, .${classDefaults.infoInlineLayerClass}`);
      if (hasTooltip) {
        tooltipWithinModal = true;
      }
    }


    const $closeButton = $layer.find(`.${this.options.closeClass}`).eq(0);


    $closeButton.each((index, element) => {
      if (
        o.type === 'modal'
        && $(element).closest(`.${linkDefaults.layerClass}`).hasClass('spa-ui-info-info-inline')
      ) {
        $closeButton.splice($.inArray(element, $closeButton), 1);
      }
    });


    const _closeLayer = function _closeLayer() {
      this.closeLayer($layer);


      if (o.type !== 'info-inline') {
        this.options.$body.off(`keydown.${this.options.evtNamespace}`);
      }
    };

    $closeButton
      .off(`click.${this.options.evtNamespace}`)
      .on(`click.${this.options.evtNamespace}`, _closeLayer.bind(this));


    if (o.closeOnEscape && o.closeButton === true) {
      const _closeLayerOnEscape = function _closeLayerOnEscape(clickEvent) {
        if (clickEvent.keyCode === 27) {

          if (o.type !== 'info-inline') {

            this.closeLayer($layer);


            this.options.$body.off(`keydown.${this.options.evtNamespace}`);
          }
        }
      };

      this.options.$body.on(`keydown.${this.options.evtNamespace}`, _closeLayerOnEscape.bind(this));
    }


    if (o.closeOnClickOutside) {
      if (o.type !== 'info-inline') {
        const self = this;
        const mouseUpEvent = (clickEvent) => {
          if ($layer !== clickEvent.target && !$layer.has(clickEvent.target).length) {
            this.options.$body.off(`mouseup.${this.options.evtNamespace}mouseUpEventFN`);
            self.closeLayer($layer);
          }
        };
        this.options.$body.on(`mouseup.${this.options.evtNamespace}mouseUpEventFN`, mouseUpEvent.bind(this));
      }
    }


    if (o.closeTriggers && o.closeTriggers.length) {
      $(o.closeTriggers).each((i, el) => {
        const $closeLink = $layer.find(el);

        const _closeLayerWithTriggers = function _closeLayerWithTriggers() {
          this.closeLayer($layer);
        };

        $closeLink.click(_closeLayerWithTriggers.bind(this));
      });
    }

    if ((o.onOpen && o.onOpen.length) && (o.onClose && o.onClose.length)) {
      this._deprecated('The `onOpen` and `onClose` methods are no longer supported. Please use the Sparta Event Utility equivalents and `spartaEventUtility.MODAL_OPENED`/`spartaEventUtility.MODAL_CLOSED`.');
    }


    const addContent = function addContent(content) {
      $layer.find('.site-specific-placeholder-content').html(content);
      resizeContentBody.call(this);
    };


    const replaceContent = function replaceContent(content) {

      if (!$layer || !$layer.length) {
        return;
      }
      const layer = $layer[0];
      if (!layer) {
        return;
      }


      const target = layer.querySelector(`#${contentId}`, `.${contentId}`);
      const loading = layer.querySelector('.spa-loading');
      const buttonGroup = target.querySelector('.spa-btn-group');
      const contentEl = target.querySelector('.site-specific-placeholder-content');


      document.activeElement.blur();


      const html = document.createElement('div');
      html.classList.add('content');


      if (typeof content === 'string') {

        html.insertAdjacentHTML('beforeend', content);
      } else {

        html.appendChild(content);
      }


      if (contentEl) {
        html.appendChild(contentEl);
      }
      if (buttonGroup) {
        html.appendChild(buttonGroup);
      }


      if (loading) {
        loading.remove();
      }


      target.querySelector('.content').remove();


      target.appendChild(html);
      target.style.display = 'block'; 


      const dismissible = layer.querySelector('.spa-card__dismissible');
      if (dismissible) {
        dismissible.focus();
      }
    };


    const addLoader = function addLoader(text) {

      if (!$layer || !$layer.length) {
        return;
      }
      const layer = $layer[0];
      if (!layer) {
        return;
      }


      const content = layer.querySelector(`#${contentId} .content`, `.${contentId} .content`);
      content.style.display = 'none';


      const loadingText = text || o.loadingText;
      const spaBody = layer.querySelector('.spa-body')
        ? layer.querySelector('.spa-body')
        : layer.querySelector('.spa-card__body');
      const loading = document.createElement('div');
      loading.innerHTML = loadingText;
      loading.classList.add('spa-loading');
      loading.setAttribute('tabindex', '-1');
      spaBody.appendChild(loading);
      const modalLoading = spaBody.querySelector('.spa-loading');
      if (modalLoading) {
        modalLoading.focus();
      }
    };


    o.returnFocusToLink.addClass(this.options.openClass);


    spartaEventsUtility.pub(EVENTS.MODAL_OPENED, {
      type: o.type,
      contentId: o.contentId,
      layer: $layer,
      addLoader,
      addContent,
      replaceContent,
    });


    $layer.attr('aria-hidden', false);



    const breakpointInit = o && 'disableBP' in o
      ? o.disableBP
      : true;
    spartaEventsUtility.sub(`${spartaMediaQueryUtility.EVENTS.BREAKPOINT_CHANGE}:${o.layerId}`, () => {
      this.transportStickyFooter($layer);
    }, breakpointInit);


    const $spaBodyHeight = $layer.find('.spa-card__body').height();
    const $bodyContent = $layer.find('.content');
    if ($spaBodyHeight < $bodyContent[0].scrollHeight) {
      $bodyContent.attr('tabindex', '0');
    }


    this._addAlphaLayer(o.type, $layer.find('.spa-card__body'), true);




    $layer.on('transitionend webkitTransitionEnd oTransitionEnd', (thisEvent) => {
      const trigger = thisEvent.target;

      if (trigger.classList.contains('spa-card')) {
        if (tooltipWithinModal && $layer.hasClass(classDefaults.activeTooltip)) {
          $($layer).find('.spa-card__dismissible').eq(0).trigger('focus');
          return false;
        }
        if (
          o.dynamicContent === false
          && (
            $layer.hasClass(classDefaults.activeModal)
            || $layer.hasClass(classDefaults.activeTooltip)
          )
        ) {
          if (o.closeButton === false) {
            if (o.noCloseFocusAuto === true) {
              $layer.find(`.${classDefaults.noCloseFocus}`).eq(0).trigger('focus');
            }
          } else if (!trigger.parentElement.classList.contains('spa-ui-info-info-inline')) {
            $($layer).find('.spa-card__dismissible:first-of-type').eq(0).trigger('focus');
          }
        }
      }
    });


    const getTransitionFromCSS = window.getComputedStyle($layer[0]).getPropertyValue('animation-duration');
    if (getTransitionFromCSS) {
      const transitionTimer = parseFloat(getTransitionFromCSS) * (/\ds$/.test(getTransitionFromCSS) ? 1000 : 1);
      const getLayer = $layer[0];
      setTimeout(() => {
        const getActiveElement = document.activeElement;
        const layerHasActiveElement = getLayer.contains(getActiveElement);
        if (
          !layerHasActiveElement
          && (
            getLayer.classList.contains(classDefaults.activeModal)
            || getLayer.classList.contains(classDefaults.activeTooltip)
          )
        ) {
          if (o.closeButton === false) {
            if (o.noCloseFocusAuto === true) {
              getLayer.querySelector(`.${classDefaults.noCloseFocus}`).focus();
            }
          } else if (!getLayer.parentElement.classList.contains('spa-ui-info-info-inline')) {
            getLayer.querySelector('.spa-card__dismissible:first-of-type').focus();
          }
        }
      }, transitionTimer + 5);
    }
  }












  closeLayer(layer, actionOptions = {}) {
    if (this.isPrerender) {
      return;
    }



    let $layer;
    if (typeof layer === 'undefined') {
      $layer = $(`.${this.options.layerClass}`);
    } else if (typeof layer === 'string') {
      $layer = this.options.$applicationContainer.find(`#${layer}`).slice(0, 1);
    } else {
      $layer = $(layer);
    }


    let tooltipWithinModal = false;
    if (
      this.options.$applicationContainer.find(`.${classDefaults.infoLayerClass}`).length
      &&
      (
        this.options.$applicationContainer.find(`.${classDefaults.modalLayerClass}`).length
        ||
        this.options.$applicationContainer.find(`.${classDefaults.infoInlineLayerClass}`).length
      )
    ) {
      tooltipWithinModal = true;
    }


    if (!tooltipWithinModal) {
      focusTrap.removeTrap();
    }


    if ($layer.length === 0) {
      return;
    }

    const _onEachItem = function _onEachItem(origLayer, index, element) {
      const $this = $(element).hasClass('spa-ui-layer')
        ? $(element)
        : $(element).closest('.spa-ui-layer');
      const o = $this.data() || {};
      const getActionOptions = actionOptions;
      let $returnFocusToLink = o.returnFocusToLink;
      const doesElementExist = $this.closest('body').length > 0;
      const isCurrentlyShowing = ($this.css('display') !== 'none');

      if (!isCurrentlyShowing || !doesElementExist) {
        return;
      }


      $this.find('spa-card__head').removeClass('spa-card__head-box-shadow');
      $this.find('spa-card').removeClass('spa-card__body-box-shadow');
      $this.find('spa-card__body').removeClass('spa-card__body-box-shadow');
      $this.find('spa-card__foot').removeClass('spa-card__foot-box-shadow spa-card__foot-box-shadow--empty');


      let openInfoInline = false;
      if (!origLayer && element.classList.contains('spa-ui-info-info-inline')) {
        openInfoInline = true;
      }


      if ($layer.length === 1) {

        if (!($returnFocusToLink instanceof $)) {
          $returnFocusToLink = this.options.$applicationContainer.find($returnFocusToLink)
            .slice(0, 1);
        }


        const setFocus = 'setFocusOnClose' in getActionOptions
          ? getActionOptions.setFocusOnClose
          : true;

        if (setFocus) {
          if (o.type === 'info-inline' && !openInfoInline) {

            $layer.slideToggle();
            $returnFocusToLink.focus();
          } else if ($returnFocusToLink.length && $returnFocusToLink.is(':visible')) {
            setTimeout(() => {
              $returnFocusToLink
                .removeClass(this.options.openClass)
                .focus();
            }, 10);
          } else if (o.type === 'info' && $layer.prev().is(':visible')) {


            $layer.prev().trigger('focus');
          } else {

            this.options.$applicationContainer.focus();
          }
        }
      }


      if ($this.hasClass(this.options.modalLayerClass)) {
        this._closeModalLayer($this);
      } else if ($this.hasClass(this.options.infoLayerClass) && o.type !== 'info-inline') {
        this._closeInfoLayer($this);
      }



      spartaEventsUtility.pub(EVENTS.MODAL_CLOSED, {
        eventType: EVENTS.MODAL_CLOSED,
        type: o.type,
        contentId: o.contentId,
        layer: $layer,
      });


      spartaEventsUtility.unsubByEvent(`${spartaMediaQueryUtility.EVENTS.BREAKPOINT_CHANGE}:${o.contentId}SpartaUILayer`);


      if ($returnFocusToLink) {
        if (window.tooltipFN) {
          window.removeEventListener('resize', window.tooltipFN, false);
          window.removeEventListener('scroll', window.tooltipFN, false);
        }
      }


      $this.data('returnFocusToLink', null);


      $this.attr('aria-hidden', true);

      if ($this.hasClass(this.options.modalLayerClass) && o.type === 'modal') {

        this._bodyUnfreezeScroll($this);
        this.options.$applicationContainer.removeClass(classDefaults.activeModal);
        $layer.removeClass(classDefaults.activeModal);
      } else if ($this.hasClass(this.options.infoLayerClass)) {

        this.options.$applicationContainer.removeClass(classDefaults.activeTooltip);
        $layer.removeClass(classDefaults.activeTooltip);
      }
    };


    $layer.each(_onEachItem.bind(this, layer));

    this.options.$body.off(`click.${this.options.closeLayerNameSpace}`);
  }






  _keepPageFromScrolling() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.options.$body.css('top', -scrollTop);
  }






  _bodyFreezeScroll($layer) {
    if ($layer.length) {

      if (!this.options.$body.hasClass('spa-ui-no-js-scroll')) {
        this._keepPageFromScrolling();
      }

      this.options.$body.addClass('spa-ui-freeze-scroll');
      spartaEventsUtility.pub(EVENTS.FREEZE_SCROLL);
    }
  }





  _returnScrollLocation() {
    const computedStyles = window.getComputedStyle(document.body, null);
    const topValue = computedStyles.getPropertyValue('top');
    const topValueToInteger = Math.abs(parseInt(topValue, 10));
    window.scrollTo(0, topValueToInteger);
    this.options.$body.css('top', '');
  }






  _bodyUnfreezeScroll($layer) {
    if ($layer.length && this.options.$body.hasClass('spa-ui-freeze-scroll')) {

      this.options.$body.removeClass('spa-ui-freeze-scroll');


      if (!this.options.$body.hasClass('spa-ui-no-js-scroll')) {
        this._returnScrollLocation();
      }

      spartaEventsUtility.pub(EVENTS.UNFREEZE_SCROLL);
    }
  }






  _closeModalLayer($layer) {
    $layer.css('display', 'none');

    const $spaContent = $layer.find('.content');
    if ($spaContent && $spaContent.length) {
      $spaContent[0].scrollTop = 0;
      if ($spaContent.attr('tabindex')) {
        $spaContent.removeAttr('tabindex');
      }
      const $alphaLayer = $spaContent.find('.spa-content-alpha-layer');

      if ($alphaLayer && $alphaLayer.length) {
        $spaContent.off('scroll.uilayer_content');
      }

      this.updatePageContainerADA(false);
    }
  }






  _closeInfoLayer($layer) {
    if ($layer.hasClass('spa-ui-animate-fadeInDown')) {
      $layer
        .removeClass('spa-ui-animate-fadeInDown')
        .addClass('spa-ui-animate-fadeOutUp');
    } else if ($layer.hasClass('spa-ui-animate-fadeInUp')) {
      $layer
        .removeClass('spa-ui-animate-fadeInUp')
        .addClass('spa-ui-animate-fadeOutDown');
    }

    const $spaContent = $layer.find('.content');
    if ($spaContent.length) {
      $spaContent[0].scrollTop = 0;
      if ($spaContent.attr('tabindex')) {
        $spaContent.removeAttr('tabindex');
      }
    }

    const $alphaLayer = $spaContent.find('.spa-content-alpha-layer');
    if ($alphaLayer) {
      $spaContent.off('scroll.uilayer_content');
    }
  }





  _getNextZindex() {
    return this.options.nextZIndex++;
  }














  _formatCloseLink(o) {

    o.titleText = '';
    if (o.closeAdaTextOverride) {
      o.titleText = o.closeAdaTextOverride;
    } else {

      const existingTitle = o.$content.closest('.spa-card').find('.spa-card__title');
      let $titleEl = o.$content.find('.spa-ui-layer-title')
        ? o.$content.find('.spa-ui-layer-title')
        : o.$content.parent().find('.spa-ui-layer-title');


      if (existingTitle && existingTitle.length > 0) {
        $titleEl = existingTitle;
      } else { 

        $titleEl = o.$content.find('.spa-ui-layer-title')
          ? o.$content.find('.spa-ui-layer-title')
          : o.$content.parent().find('.spa-ui-layer-title');


        if (!$titleEl.length && o.type === 'modal') {
          $titleEl = o.$content.find('h1').first();
        } else if (!$titleEl) {
          $titleEl = o.$content.find('h3').first();
        }


        if (!$titleEl.length) {
          $titleEl = o.$content.find('h2').first();
        }
        if (!$titleEl.length) {
          $titleEl = o.$content.find('h4').first();
        }
        if (!$titleEl.length) {
          $titleEl = o.$content.find('.ada-title').first();
        }
      }


      if ($titleEl.length) {
        o.titleText = $titleEl.text().trim();
      } else if ( 
        o.returnFocusToLink.length
        && o.returnFocusToLink.text().length
        && !o.returnFocusToLink.is('[data-sparta-container]')
      ) {
        o.titleText = o.returnFocusToLink.text().replace(/layer/g, '');
      } else { 
        const $paragraphEl = o.$content.find('p').first();
        if ($paragraphEl.length) {
          o.titleText = $paragraphEl.text().substr(0, 50);
        }
      }
    }


    if (o.closeButton === false) {
      o.closeText = ' ';
    }


    let moreCloseText;

    if (o.type === 'modal') {
      moreCloseText = o.closeAdaText
        || spartaGlobalFunctions.getGlobalParams('closeModalADAText')
        || 'modal';
    } else {
      moreCloseText = spartaGlobalFunctions.getGlobalParams('closeLayerADAText') || 'layer';
    }
    o.closeAdaText += moreCloseText;
    if (o.titleText) {
      o.closeAdaText += `${o.closeAdaTextSpacer} ${o.titleText}`;


      o.closeAdaTextClean = `${o.titleText}`;
    }
  }














  _getLayerPos($layer, $link) {


    const link = $link[0].getBoundingClientRect();


    const viewport = {
      width: this.options.$window.width(),
      height: this.options.$window.height(),
    };


    const layer = {
      width: $layer.width(),
      height: $layer.height(),
    };

    const center = this._getLinkCenter(link);


    return {
      x: this._getLayerX(link, layer, viewport, $link),
      y: this._getLayerY(link, layer, viewport, $link),
      center,
    };
  }






  _getLinkCenter(link) {
    return link.left + (link.width / 2);
  }









  _getLayerY(link, layer, viewport, $link) {

    const CARET_HEIGHT = 8;
    const layerHeight = layer.height + CARET_HEIGHT;
    const bleedOffBottom = Math.max(0, link.bottom - (viewport.height - layerHeight));
    const bleedOffTop = Math.max(0, layerHeight - link.top);


    let direction = (bleedOffBottom && !bleedOffTop) ? -1 : 1;


    const linkOptions = $link.data('options') || {};
    if (linkOptions.position === 'top') {
      direction = -1;
    } else if (linkOptions.position === 'bottom') {
      direction = 1;
    }

    return direction;
  }














  _getLayerX(link, layer, viewport, $link) {
    const center = this._getLinkCenter(link);


    let x = 0;
    let layerWidth = layer.width / 2;
    if ($link.hasClass('icon-link')) {
      layerWidth = (layer.width * 0.8);
    }
    if ((layerWidth) >= viewport.width) {

      x = 3;
    } else if ((layerWidth >= center) && (layerWidth >= viewport.width - center)) {


      x = 2;
    } else if (center - layerWidth <= 0) {


      x = -1;
    } else if (center + layerWidth >= viewport.width) {


      x = 1;
    }

    return x;
  }








  _openModalLayer(o, $layer, $link) {

    this.closeLayer();



    const _widthValue = o.width || o.modalLayer.width;


    $layer = this.options.$applicationContainer.find(`#${o.layerId}`).slice(0, 1);


    if ($layer.length) {


      if (this.layers[o.interstitialType]) {
        SpartaUILayersModal.updateModalCTA($layer, $link.attr('href'));
      } else {

        this._formatCloseLink(o);
        $($layer).find('.spa-card__dismissible').eq(0).attr('aria-label', `${o.closeText} ${o.closeAdaText}`);
      }

      $layer.removeClass('full-width');
      $layer.css('display', 'block');
    } else {

      this._formatCloseLink(o);


      const modalDOMElement = SpartaUILayersModal.buildHTML(
        this,
        o,
        $link,
        classDefaults,
        linkDefaults,
      );


      this.options.$applicationContainer.append(modalDOMElement);


      $layer = this.options.$applicationContainer.find(`#${o.layerId}`).slice(0, 1);



      $layer.wrapInner('<div class="spa-layer-content"></div>');
      $layer.find('.spa-layer-content').wrapInner('<div class="spa-dialog"></div>');
      $layer.find('.spa-dialog').css('width', _widthValue);
    }


    this._updateLinksDataCollection();


    $layer = this.options.$applicationContainer.find(`#${o.layerId}`).slice(0, 1);


    this._bodyFreezeScroll($layer);


    const $modalDialog = $layer.find('.spa-dialog');
    const _layerWidth = $modalDialog.width();


    if (o.position.browserWidth <= _layerWidth) {
      $modalDialog.addClass('full-width');
    }





    function closeModal() {
      this.options.$window.off('resize.closeModal orientationchange.closeModal');
      this.closeLayer(o.layerId);
    }


    this.options.$applicationContainer.find('.close-interstitial.spa-btn')
      .off('click')
      .on('click', closeModal.bind(this));


    focusTrap.setContainer($modalDialog[0]).attachTrap();
    this.updatePageContainerADA(true);


    if (classDefaults.layerPosition) {
      $modalDialog.parent()
        .addClass(`spa-ui-position-${classDefaults.layerPosition.toLowerCase()}`);
    }

    return $layer;
  }








  _addAlphaLayer(layertype, $baseLayer, addListener = false) {

    $baseLayer = $baseLayer instanceof jQuery
      ? $baseLayer
      : $($baseLayer);

    const $spaBody = $baseLayer.hasClass('spa-card__body')
      ? $baseLayer
      : $baseLayer.find('.spa-card__body');

    const $spaCard = $spaBody.closest('.spa-card');
    const $bodyContent = layertype === 'info'
      ? $baseLayer.find('.content')
      : $baseLayer;


    const alphaLogic = () => {
      if ($spaBody.length === 0) {
        return;
      }


      const $spaHead = $spaCard.find('.spa-card__head');
      const $spaFoot = $spaCard.find('.spa-card__foot');
      const $spaBodyHeight = $spaBody.height();
      const hasFoot = $spaFoot && $spaFoot.length > 0;
      const emptyFootContent = $spaFoot.children().length === 0;
      const bodyScrolledPOS = (
        $bodyContent[0].scrollHeight
        - $bodyContent.scrollTop()
        - $bodyContent.outerHeight()
      );
      const bodyScrolledBottom = bodyScrolledPOS < 1;


      if ($spaBodyHeight < $bodyContent[0].scrollHeight) {

        if ($bodyContent[0].scrollTop > 0) {
          $spaHead[0].classList.add('spa-card__head-box-shadow');
        } else {
          $spaHead[0].classList.remove('spa-card__head-box-shadow');
        }


        if (emptyFootContent && !bodyScrolledBottom && bodyScrolledPOS > 8) {
          if (layertype === 'modal') {
            $spaCard[0].classList.add('spa-card__body-box-shadow');
          }
          else {
            $spaBody[0].classList.add('spa-card__body-box-shadow');
          }
        } else {
          $spaBody[0].classList.remove('spa-card__body-box-shadow');
          $spaCard[0].classList.remove('spa-card__body-box-shadow');
        }


        if (hasFoot && bodyScrolledBottom) {
          $spaFoot[0].classList.remove('spa-card__foot-box-shadow');
        } else if (hasFoot) {
          $spaFoot[0].classList.add('spa-card__foot-box-shadow');
        }
      }

      else {
        $spaHead[0].classList.remove('spa-card__head-box-shadow');
        $spaBody[0].classList.remove('spa-card__body-box-shadow');
        $spaCard[0].classList.remove('spa-card__body-box-shadow');
        if (hasFoot) {
          $spaFoot[0].classList.remove('spa-card__foot-box-shadow');
        }
      }


      if (hasFoot && emptyFootContent) {
        $spaFoot[0].classList.add('spa-card__foot-box-shadow--empty');
      } else if (hasFoot) {
        $spaFoot[0].classList.remove('spa-card__foot-box-shadow--empty');
      }


      if ($bodyContent[0].scrollHeight < 225) {
        $bodyContent[0].style.minHeight = '';
      }
    };


    alphaLogic();
    if (addListener) {
      $spaBody.off('click.alphaLogicClick').on('click.alphaLogicClick', () => {
        alphaLogic();
      });

      $bodyContent.off('scroll.alphaLogicScroll').on('scroll.alphaLogicScroll', () => {
        alphaLogic();
      });

      $(window).off('resize.alphaLogicResize').on('resize.alphaLogicResize', () => {
        alphaLogic();
      });
    }
  }







  _showHideAlphaOverlay(currentTarget, $alphaLayer) {
    let displayValue = 'none';


    const alphaLayerHeight = 40;


    if (currentTarget.scrollHeight > alphaLayerHeight) {



      if (currentTarget.scrollTop + currentTarget.clientHeight + 1 < currentTarget.scrollHeight) {
        displayValue = 'block';
      }
    }

    $alphaLayer.css('display', displayValue);
  }








  _openInfoLayer(o, $layer, $link) {

    let withinModal = false;
    const linkOptions = $link.data('options') || {};
    let tooltipMaxHeight = linkOptions.maxHeight || o.maxHeight || o.height || null;


    const _self = this;


    if (
      this.options.$applicationContainer
        .find(`.${classDefaults.modalLayerClass}`)
        .find($link).length
    ) {
      withinModal = true;
    }


    const remainOpen = 'remainOpen' in o
      ? o.remainOpen
      : false;


    $layer = this.options.$applicationContainer.find(`#${o.layerId}`);


    if (
      $link.next().hasClass('spa-ui-layer')
      && $layer.find('.content').length
      && $layer.is(':visible')
      && (!remainOpen)
    ) {
      const $layerFocusCheckDelay = 25;
      setTimeout(() => {
        if (o.type === 'info-inline') {

          const $closeButton = $layer.find(`.${this.options.closeClass}`);
          this.inlineTooltipSlideToggle($layer, $closeButton, 150);
        } else {
          _self.closeLayer($layer);
        }
      }, $layerFocusCheckDelay);
      return $layer;
    }


    if (!$layer.find('.content').length) {

      this._formatCloseLink(o);


      const infoLayerHTML = SpartaUILayersTooltip.buildHTML(this, o, $link);


      $link.after(infoLayerHTML);


      if (tooltipMaxHeight) {
        $(infoLayerHTML).find('.content').css('max-height', `${tooltipMaxHeight}px`);
      }


      infoLayerHTML.firstElementChild.appendChild(SpartaUILayersTooltip.createEndOfElement(o));


      $layer = this.options.$applicationContainer.find(`#${o.layerId}`);
    }

    else if ($layer.hasClass('spa-ui-animate-fadeOutUp') || $layer.hasClass('spa-ui-animate-fadeOutDown')) {

      this._formatCloseLink(o);
      $($layer).find('.spa-card__dismissible').eq(0).attr('aria-label', `${o.closeText} ${o.closeAdaText}`);


      $layer.show();


      $link.after($layer);

      $layer.css('top', '');
    }

    else if (o.type === 'info-inline') {

      const $closeButton = $layer.find(`.${this.options.closeClass}`);
      this.inlineTooltipSlideToggle($layer, $closeButton, 150);
    }


    $layer.removeClass('spa-ui-info-modal spa-ui-animate-fadeOutUp spa-ui-animate-fadeOutDown');


    if (o.width) {
      $layer.css('max-width', o.width);
    }


    if (tooltipMaxHeight) {

      if (tooltipMaxHeight.includes('px')) {
        tooltipMaxHeight = tooltipMaxHeight.replace('px', '');
      }


      $layer.find('.content').css('max-height', `${tooltipMaxHeight}px`);
    }


    this._tooltipPositioning(_self, $layer, $link, withinModal, o);


    this.options.$window.on('scroll resize', () => {
      _self._tooltipPositioning(_self, $layer, $link, withinModal, o);
    });

    return $layer;
  }







  _getElementPosition(element, position) {
    const elemRect = element.getBoundingClientRect();
    const appRect = this.options.$applicationContainer[0].getBoundingClientRect();

    if (position === 'top') {
      return elemRect.top - appRect.top;
    }
    return elemRect.left - appRect.left;
  }








  inlineTooltipSlideToggle($layer, $closeButton, timer) {
    $layer.slideToggle(timer, () => {
      if ($layer.is(':visible')) {
        $layer.attr('aria-hidden', 'false');
        $closeButton.attr('aria-hidden', 'false');
        $closeButton.trigger('focus');
      } else {
        this.closeLayer($layer);
      }
    });
  }






  updatePageContainerADA(isHidden) {
    if (this.isPrerender) {
      return;
    }

    const $pageContainer = this.options.$document.find(classDefaults.spartaLayoutContainer);
    if ($pageContainer.length && !this.options.$applicationContainerDisableAriaHiddenToggle) {
      $pageContainer.attr('aria-hidden', isHidden);
    }
  }





  _updateLinksDataCollection() {
    if (typeof cX === 'function') {
      cX('onload');
      this._debug('_updateLinksDataCollection(): cX scan for new links');
    }
  }






  _debug(msg) {
    if (this.options.debug) {

      console.log('ui-layer debug: ', msg);
    }
  }






  _deprecated(msg) {
    if (this.options.debug) {

      console.error(`ui-layer DEPRECATED: ${msg}`);
    }
  }










  _tooltipPositioning(_self, $layer, $link, tooltipWithinModal, o) {

    const layerPosition = _self._getLayerPos($layer, $link);
    const caretTarget = $layer.length
      ? $layer[0].querySelector('.spa-card')
      : undefined;


    const linkViewportOffset = $link[0].getBoundingClientRect();
    const linkViewportOffsetTop = linkViewportOffset.top;


    const appBoundingRect = this.options.$applicationContainer[0].getBoundingClientRect();
    let newLeft = this._getElementPosition($link[0]);
    const layerCenter = $layer.outerWidth() / 2;
    const linkCenter = $link.outerWidth() / 2;


    const caretClasses = {
      top: 'card-caret-top',
      topRight: 'card-caret-top-right',
      topLeft: 'card-caret-top-left',
      bottom: 'card-caret-bottom',
      bottomRight: 'card-caret-bottom-right',
      bottomLeft: 'card-caret-bottom-left',
      right: 'card-caret-right',
      left: 'card-caret-left',
    };


    if (caretTarget) {
      Object.values(caretClasses).forEach((item) => {
        caretTarget.classList.remove(item);
      });
    }


    if (caretTarget) {
      if (layerPosition.y === 1) {
        if (layerPosition.x === 0) {

          caretTarget.classList.add(caretClasses.top);
        } else if (layerPosition.x === 1) {

          caretTarget.classList.add(caretClasses.topRight);
        } else if (layerPosition.x === -1) {

          caretTarget.classList.add(caretClasses.topLeft);
        }
      } else if (layerPosition.x === 0) {

        caretTarget.classList.add(caretClasses.bottom);
      } else if (layerPosition.x === 1) {

        caretTarget.classList.add(caretClasses.bottomRight);
      } else if (layerPosition.x === -1) {

        caretTarget.classList.add(caretClasses.bottomLeft);
      }
    }

    if (layerPosition.x === 0) {


      newLeft = ((newLeft - ($layer.outerWidth() * 0.5)) + linkCenter);
    } else if (layerPosition.x === 1) {

      newLeft = (newLeft - $layer.outerWidth() - 2) + $link.outerWidth();
    } else if (layerPosition.x === 2) {
      newLeft = (appBoundingRect.right - layerCenter);
    } else if (layerPosition.x === -1) {


      if ($link.hasClass('icon-link')) {
        newLeft -= (40 - (linkCenter * 1.9));
      }
    }

    $layer.css({
      position: '',
      top: '',
      left: `${newLeft}px`,
      right: '',
      height: '',
      'max-width': o.width || '',
    });

    if (!tooltipWithinModal) {

      if (layerPosition.y === -1) { 
        let newTop = (linkViewportOffsetTop - $layer.outerHeight()) - this.options.layerLinkOffset;
        if ($link.hasClass('icon-link')) {
          newTop += (this.options.layerIconOffset - 6);
        }


        $layer
          .css('top', `${newTop}px`)
          .addClass('spa-ui-animate-fadeInUp')
          .removeClass('spa-ui-animate-fadeInDown');
      } else if (layerPosition.y === 1) { 
        let newTop = linkViewportOffsetTop + this.options.layerLinkOffset + this.options.layerCaret;
        if ($link.hasClass('icon-link')) {
          newTop += this.options.layerIconOffset;
        }


        $layer
          .css('top', `${newTop}px`)
          .addClass('spa-ui-animate-fadeInDown')
          .removeClass('spa-ui-animate-fadeInUp')
          .removeClass(caretClasses.top);
      }
    }



    if (
      tooltipWithinModal === true
      || (spartaMediaQueryUtility.getCurrentViewport().mediaQueryInfo.medium === false)
    ) {

      Object.values(caretClasses).forEach((item) => {
        if (caretTarget) {
          caretTarget.classList.remove(item);
        }
      });


      $layer.css('left', '10px');

      if (o.width) {
        $layer.css('max-width', '');
      }
    }


    if (tooltipWithinModal === true) {
      $layer.css({
        position: 'absolute',
        top: '',
        left: '10px',
        'max-width': 'calc(100% - 30px)',
        'margin-top': `${this.options.layerLinkOffset}px`,
      });
    }


    $layer.removeClass('spa-ui-info-modal');
  } 







  tooltipDynamicHeight(contentDiv, $link) {
    if (!contentDiv || !$link) {
      return;
    }


    if (contentDiv.scrollHeight < 225) {
      contentDiv.style.minHeight = '';
      return;
    }


    const getContent = contentDiv instanceof jQuery
      ? contentDiv[0]
      : contentDiv;
    const link = $link instanceof jQuery
      ? $link[0]
      : $link;


    const layer = getContent.closest('.spa-ui-layer');


    const cardHead = layer && layer.querySelector('.spa-card__head')
     ? layer.querySelector('.spa-card__head')
     : undefined;
    const cardHeadHeight = cardHead
      ? cardHead.getBoundingClientRect().height
      : 0;


    const cardFoot = layer && layer.querySelector('.spa-card__foot')
     ? layer.querySelector('.spa-card__foot')
     : undefined;
    const cardFootHeight = cardFoot
      ? cardFoot.getBoundingClientRect().height
      : 0;

    const triggerBottomPosition = link.getBoundingClientRect().bottom > 0
      ? link.getBoundingClientRect().bottom + (cardHeadHeight + cardFootHeight)
      : cardHeadHeight + cardFootHeight;


    const cardPartsOffset = 293 - (cardHeadHeight + cardFootHeight);
    const bottomDistanceOffset = 66;
    const bottomDistance = (window.innerHeight - triggerBottomPosition) - bottomDistanceOffset;
    contentDiv.style.maxHeight = `${bottomDistance}px`;


    if (contentDiv.scrollHeight > cardPartsOffset) {
      contentDiv.style.minHeight = `${cardPartsOffset}px`;
    } else {
      contentDiv.style.minHeight = '';
    }


    this._addAlphaLayer('info', contentDiv);
  }









  setModalTitle(modalId, content, updateAdaText = false) {
    if (this.isPrerender) {
      return;
    }


    let $layer = this.options.$applicationContainer
      .find(`#${modalId}${classDefaults.adaLayerID}`);
    if (!$layer.length) {
      $layer = this.options.$applicationContainer.find(`#${modalId}`);
    }


    if ($layer.length) {
      SpartaUILayersModal.setTitle($layer, content, updateAdaText, modalId);
    }
  }









  setTooltipTitle(tooltipId, content, updateAdaText = false) {
    if (this.isPrerender) {
      return;
    }


    let $layer = this.options.$applicationContainer
      .find(`#${tooltipId}${classDefaults.adaLayerID}`);
    if (!$layer.length) {
      $layer = this.options.$applicationContainer.find(`#${tooltipId}`);
    }


    if ($layer.length) {
      SpartaUILayersTooltip.setTitle($layer, content, updateAdaText, tooltipId);
    }
  }







  createStickyFooter(layerElement, layerOptions) {
    let layerFooterElement = document.createDocumentFragment();
    const contentFooter = layerElement.querySelector('[data-modal-footer]')
      ? layerElement.querySelector('[data-modal-footer]')
      : '';

    if (contentFooter) {

      const footerClasses = [...contentFooter.classList];
      const footerConfig = layerOptions.foot && layerOptions.foot.config
        ? layerOptions.foot.config
        : {};
      const footerLayout = footerConfig.layout || 'inline';
      const footerUnsticky = footerConfig.unsticky || {
        small: true,
        medium: false,
        large: false,
      };
      const footerStack = {
        desktop: 'stackOnDesktop' in footerConfig
          ? footerConfig.stackOnDesktop
          : false,
        tablet: 'stackOnTablet' in footerConfig
          ? footerConfig.stackOnTablet
          : false,
        mobile: 'stackOnMobile' in footerConfig
          ? footerConfig.stackOnMobile
          : false,
      };


      layerFooterElement = document.createElement('div');


      footerClasses.push('spa-card__foot', 'spa-card__foot--sticky');
      footerClasses.forEach(item => layerFooterElement.classList.add(item));


      layerFooterElement.setAttribute('data-sticky', JSON.stringify(footerUnsticky));
      layerFooterElement.setAttribute('data-layout', footerLayout);
      Object.keys(footerStack).forEach((key) => {
        if (key in footerStack) {
          layerFooterElement.setAttribute(`data-stacked-${key}`, footerStack[key]);
        }
      });


      if (contentFooter.children && contentFooter.children.length > 0) {
        const content = [...contentFooter.children];
        content.forEach((element) => {
          layerFooterElement.appendChild(element);
        });
      }
    }


    return layerFooterElement;
  }







  transportStickyFooter(layer, forceSticky) {

    let activeLayer = layer;
    if (layer instanceof jQuery) {
      activeLayer = $(layer)[0];
    }


    if (!activeLayer) {
      return;
    }


    const layerBody = activeLayer.querySelector('.spa-card__body');
    const layerFooter = activeLayer.querySelector('.spa-card__foot');


    if (layerBody && layerFooter) {
      const layerSticky = layerBody.querySelector('[data-modal-footer="sticky"]');
      const dataSticky = layerFooter.getAttribute('data-sticky')
        ? JSON.parse(layerFooter.getAttribute('data-sticky'))
        : undefined;


      if (dataSticky && layerSticky) {

        const unstick = forceSticky || this.getLayerStickyBoolean(dataSticky);


        const stickyItems = unstick
          ? [...layerFooter.children]
          : [...layerSticky.children];


        if (unstick) {
          stickyItems.forEach((item) => {
            layerSticky.appendChild(item);
          });
        }

        else {
          stickyItems.forEach((item) => {
            layerFooter.appendChild(item);
          });
        }
      }
    }
  }






  getLayerStickyBoolean(data) {

    let unstick = false;
    if (data) {

      const stickyOptions = data;
      const viewport = spartaMediaQueryUtility.getCurrentViewport().mediaQueryInfo;
      if (viewport.large && viewport.medium && viewport.small) {
        unstick = 'large';
      } else if (!viewport.large && viewport.medium && viewport.small) {
        unstick = 'medium';
      } else {
        unstick = 'small';
      }
      unstick = stickyOptions[unstick];
    }
    return unstick;
  }

}


const instance = new SpartaUILayersUtility();
spartaSingletonUtility('SpartaUILayersUtility', () => instance);
export default instance;
